module.exports = __webpack_public_path__ + "static/media/accounts-registration@2x.013db5ac.jpg";